import useSWR from "swr";
import fetcher from "./fetcher";

const FIVE_MINUTES = 5 * 60 * 1000;

export default function usePolicy(slug) {
  const { data, isLoading, error, mutate } = useSWR(
    slug ? `/api/policy/${encodeURIComponent(slug)}` : null,
    fetcher,
    { dedupingInterval: FIVE_MINUTES },
  );

  return {
    policy: data ?? null,
    isLoading,
    isError: Boolean(error),
    error,
    mutate,
  };
}
